const values = {
  center: "sm:self-center",
  end: "sm:self-end",
  start: "sm:self-start",
  none: "sm:self-auto",
};

export default function getAlignSelfSm(align) {
  return values[align];
}
